export enum IssueBulkDeleteConfirmationOpenedFrom {
  TopBar = "TopBar",
  BulkEditPanel = "BulkEditPanel",
}
